(function ($) {
  Drupal.behaviors.aboutCauses = {
    attach: function (context) {
      $('.js-partner-toggle', context).on('click', function (event) {
        event.preventDefault();
        $(this).toggleClass('active');
        $(this).parents('.js-partner').find('.js-partner-copy').stop(true, true).slideToggle();
      });
    }
  };
})(jQuery);
